import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SalesGroup } from '~shared-components/api/sales-groups'
import { CustomerContext } from '~shared-components/transforms/user.transforms'

export interface LoginState {
  initialized: boolean
  selectedCustomerContext: CustomerContext | undefined
  selectedLocationId: string | undefined
  selectedSalesGroup: SalesGroup | undefined
}

export const initialLoginState: LoginState = {
  initialized: false,
  selectedCustomerContext: undefined,
  selectedLocationId: undefined,
  selectedSalesGroup: undefined,
}

export const loginSlice = createSlice({
  initialState: initialLoginState,
  name: 'login',
  reducers: {
    setSelectedContextAction(
      state: LoginState,
      {
        payload: { context, locationId },
      }: PayloadAction<{
        context: CustomerContext | undefined
        locationId: string
      }>,
    ) {
      state.initialized = true
      state.selectedCustomerContext = context
      state.selectedLocationId = locationId
      if (context?.salesGroup) {
        state.selectedSalesGroup = context?.salesGroup
      }
    },

    setSelectedLocationAction(
      state,
      { payload }: PayloadAction<string | undefined>,
    ) {
      state.selectedLocationId = payload
    },

    setSelectedSalesGroupAction(state, { payload }: PayloadAction<SalesGroup>) {
      state.selectedSalesGroup = payload
    },
  },
})

export default loginSlice.reducer
